<template>
  <div class="app">
    <!--<div id="nav">-->
    <!--<router-link to="/">Home</router-link> |-->
    <!--<router-link to="/about">About</router-link>-->
    <!--</div>-->
    <router-view />
    <SocialNav />
  </div>
</template>

<script>
import SocialNav from './components/social/Nav'

export default {
  components: {
    SocialNav
  }
}
</script>

<style lang="scss">
html,
body {
  font-size: calc(1em + 1vw);
}

body {
  @import url('https://fonts.googleapis.com/css?family=EB+Garamond');

  background: #00242a url('assets/binding-dark.png');

  &::after {
    position: fixed;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    content: '';

    box-shadow: 0 0 200px rgba(0, 0, 0, 0.3) inset;
  }
}

.app {
  display: flex;

  height: 100vh;
  min-height: 400px;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: 'EB Garamond', serif;
  color: white;
  text-align: center;

  align-items: center;
}
</style>
